import { useDebounceFn } from "@vueuse/core";

export function createTrpcPlugin(options) {
  return function trpcPlugin(node) {
    const trpc = node.props.attrs.trpc;
    const getClient = node.props.attrs.client;
    const route = node.props.attrs.route;
    const procedure = node.props.attrs.procedure || "autocomplete";
    const additionalFields = { ...node.props.attrs?.["additional-fields"] || {} };

    if (!trpc) {
      return;
    }
    const client = getClient();

    if (!client || !route) {
      console.warn("FormKit tRPC Select: Missing required properties (client, route, procedure)");
      return;
    }

    const search = ref("");
    node.props.search = search;

    let currentRequest: any = null;
    let ac: any = null;

    async function fetchOptions(searchQuery = "") {
      if (ac && currentRequest) {
        ac.abort();
      }

      ac = new AbortController();
      currentRequest = client[route][procedure].query({
        query: searchQuery,
        version: 2, ...additionalFields
      }, { signal: ac.signal });

      try {
        const response = await currentRequest;
        ac = null;
        currentRequest = null;
        return response.map((item) => ({
          label: item.label || item.value,
          value: item.value
        }));
      } catch (error) {
        console.log(error.name)
        if (error.name !== "AbortError") {
          console.error("Error fetching options:", error);
        }
        return [];
      }
    }

    const debouncedFetchOptions = useDebounceFn(async (query) => {
      node.props.options = await fetchOptions(query);
    }, 1);

    watch(() => search.value, (newValue) => {
      debouncedFetchOptions(newValue);
    }, { immediate: true });
  };
}
